import { MenuItem, MenuItemProps } from "@mui/material";

const SelectOption = ({ children, ...props }: MenuItemProps) => {
  return <MenuItem {...props}>{children}</MenuItem>;
};
export default SelectOption;
